import axios from "axios";

const URL = 'https://isolution.dev.br:8091/appclient';
//const URL = 'http://localhost:8091/appclient';

const api = axios.create({
    baseURL: URL
});

export default api;